// extracted by mini-css-extract-plugin
module.exports = {"img":"cta-image-component_img__34LaU"};